import { Navigate } from 'react-router'

import useUser from 'src/core/contexts/UserContext/hooks/useUser'
import { ROUTES } from 'src/routes'

type Roles = 'user' | 'orgAdmin' | 'superAdmin'

interface Props {
	allowedRoles: Roles[]
	element: React.ReactNode
}

const RoleProtectedRoute = (props: Props) => {
	const { allowedRoles, element } = props

	const { user, loadingUser } = useUser()

	if (loadingUser) {
		return null
	}

	const { orgAdmin, superAdmin } = user || {}
	const hasAccess = resolveAccess(allowedRoles, !!orgAdmin, !!superAdmin)

	if (!hasAccess) {
		return <Navigate to={ROUTES.NOT_FOUND} replace />
	}

	return <>{element}</>
}

const resolveAccess = (allowedRoles: Roles[], orgAdmin: boolean, superAdmin: boolean) => {
	if (allowedRoles.includes('user')) {
		return true
	}

	if (allowedRoles.includes('orgAdmin') && orgAdmin) {
		return true
	}

	if (allowedRoles.includes('superAdmin') && superAdmin) {
		return true
	}

	return false
}

export default RoleProtectedRoute
